import React, { forwardRef, useMemo, useRef } from 'react';

import { Backdrop, CircularProgress, makeStyles, Theme, Typography } from '@material-ui/core';
import { useAsset, useInit, useWkblScript } from 'hooks';
import { useSelector } from 'react-redux';
import { LibraryState, RootState } from 'redux/reducers/type';

const useStyles = makeStyles((theme: Theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    display: 'flex',
    flexDirection: 'column',

    color: '#fff',
  },
  text: {
    marginTop: '1em',
  },
}));

function PageLoading() {
  const classes = useStyles();
  const { isLoading: isAssetLoading } = useSelector((state: RootState) => state.wkblScript);

  const { isLoading: isWkblScriptLoading } = useSelector((state: RootState) => state.wkblVideo);

  const { isLoadingInsert } = useSelector((state: RootState) => state.library);

  const { isInit } = useInit();

  const isLoading = useMemo(() => {
    return isAssetLoading || isWkblScriptLoading || isLoadingInsert;
  }, [isAssetLoading, isWkblScriptLoading, isLoadingInsert]);

  return (
    <Backdrop className={classes.backdrop} open={isLoading || !isInit}>
      <CircularProgress color="inherit" />
      <Typography className={classes.text}>잠시만 기다려주세요</Typography>
    </Backdrop>
  );
}

export default PageLoading;
